export default function Django_Add_Bootstrap5() {
  return <div>Django_Add_Bootstrap5 Component</div>;
}
